import { render } from "./DegreeDataLogo.vue?vue&type=template&id=42a24c2a"
import script from "./DegreeDataLogo.vue?vue&type=script&lang=js"
export * from "./DegreeDataLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__